import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Pokemon from '../../components/pokemon'
import { notification } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { add, next, previous, resetPage } from '../../redux/actions'
import Button from '../../components/button/'
import Container from '../../styled/styled-container'
import RickAndMorty from '../../components/rick-and-morty'

const Characters = () => {

  const { list } = useParams()
  const history = useHistory()

  const dispatch = useDispatch()
  const page = useSelector((state) => state.page.page)
  const characters = useSelector((state) => state.charactersHome.charactersHome)

  const handleCharacters = async () => {
    if (list === 'rick-and-morty') {
      dispatch(resetPage(1))
      history.push('/characters/pokemons')
    }else {
      dispatch(resetPage(1))
      history.push('/characters/rick-and-morty')
    }
  }

  const handlePreviousPage = () => {
    if (page > 1 ) {
      dispatch(previous())
    }
  }

  const handleNextPage = () => {
    dispatch(next())
  }

  const handleSelected = (newCharacter) => {
    const alreadyAdd = characters.some(
      character => character.name === newCharacter.name
    )

    if (alreadyAdd) {
      return notification["error"]({
        key: newCharacter.name,
        message:'Erro',
        description:'Personagem já foi adicionado!',
        style:{width:'300px', right: '10px'}
      })
    }

    notification["success"]({
      key: newCharacter.name,
      message:'Sucesso',
      description: 'Personagem adicionado com sucesso!',
      style:{width:'300px', right:'10px'}
    })

    dispatch(add(newCharacter))
    localStorage.setItem('characters' , JSON.stringify([...characters, newCharacter]))
  }

  return(
    <Container>
      <Button onClick={handleCharacters} buttonTitle={list === 'pokemons' ? 'Rick And Morty' : 'Pokemon'}/>
      <div>
        <Button onClick={handlePreviousPage} buttonTitle={'Previous'} />
        <Button onClick={handleNextPage} buttonTitle='Next'/>
      </div>
      {list === 'pokemons' && <Pokemon onClick={handleSelected}/>}
      {list === 'rick-and-morty' && <RickAndMorty onClick={handleSelected} />}
    </Container>
  )
}

export default Characters